"use client";

import { useState } from "react";
import { AeraButton, SegmentedTabSwitcher, type SegmentedTabItem } from "@aera/ui";
import type { ReminderStyle } from "@/lib/reminderTemplates";

const TONE_TABS: SegmentedTabItem<ReminderStyle>[] = [
  { id: "polite", label: "😊 สุภาพ" },
  { id: "direct", label: "⚡ ตรงๆ" },
];

export function ReminderToneDrafts(props: {
  polite: string;
  direct?: string | null;
  copied: boolean;
  copyDisabled?: boolean;
  copyTestId?: string;
  onCopy: (message: string, style: ReminderStyle) => void;
}) {
  const [style, setStyle] = useState<ReminderStyle>("polite");
  const hasDirect = Boolean(props.direct?.trim());
  const selected = style === "direct" && hasDirect ? props.direct! : props.polite;

  return (
    <div className="space-y-2">
      {hasDirect ? (
        <SegmentedTabSwitcher
          tabs={TONE_TABS}
          activeTab={style}
          onChange={setStyle}
          ariaLabel="โทนข้อความทวง"
        />
      ) : null}
      <p
        key={style}
        className="whitespace-pre-wrap break-words rounded-xl bg-aera-white px-3 py-2.5 text-xs leading-relaxed text-aera-charcoal ring-1 ring-aera-charcoal/15 animate-in fade-in duration-200"
      >
        {selected}
      </p>
      <AeraButton
        type="button"
        variant="secondary"
        size="xs"
        className="cursor-pointer"
        data-testid={props.copyTestId ?? "fw-reminder-copy"}
        disabled={props.copyDisabled}
        onClick={() => props.onCopy(selected, style)}
      >
        {props.copied ? "คัดลอกแล้ว" : "คัดลอกร่าง"}
      </AeraButton>
    </div>
  );
}
